export default function OzoneLayer() {
    return (
        <svg className="w-6 h-6" fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 301.741 301.741" xmlSpace="preserve">
            <g>
                <g>
                    <g>
                        <path d="M151.604,57.122c-62.327,0-113.033,50.707-113.033,113.033s50.706,113.033,113.033,113.033
				s113.033-50.707,113.033-113.033S213.931,57.122,151.604,57.122z M225.776,110.815h-40.094
				c-5.18-13.108-12.086-24.9-20.466-34.714C189.608,79.615,211.033,92.425,225.776,110.815z M124.876,161.155
				c0.682-11.145,2.638-22.069,5.693-32.34h42.311c2.956,10.172,4.825,21.065,5.469,32.34H124.876z M178.32,179.155
				c-0.685,11.167-2.615,22.089-5.623,32.34h-42.298c-2.976-10.164-4.864-21.057-5.527-32.34H178.32z M151.682,87.939
				c5.638,6.615,10.493,14.338,14.473,22.876h-28.781C141.347,102.306,146.155,94.565,151.682,87.939z M138.132,76.081
				c-8.362,9.901-15.264,21.697-20.457,34.734H77.432C92.203,92.39,113.682,79.566,138.132,76.081z M66.043,128.815H111.8
				c-2.682,10.353-4.366,21.221-4.953,32.34H56.999C58.084,149.662,61.22,138.758,66.043,128.815z M66.043,211.495
				c-4.823-9.942-7.959-20.847-9.044-32.34h49.857c0.593,11.157,2.262,22.022,4.917,32.34H66.043z M77.432,229.495h40.193
				c5.223,13.137,12.184,24.941,20.629,34.751C113.754,260.786,92.228,247.951,77.432,229.495z M137.171,229.495h28.809
				c-3.942,8.543-8.715,16.293-14.204,22.901C146.087,245.786,141.188,238.054,137.171,229.495z M165.383,264.186
				c8.28-9.854,15.114-21.636,20.255-34.691h40.136C211.066,247.843,189.706,260.637,165.383,264.186z M237.164,211.495h-45.719
				c2.646-10.339,4.313-21.205,4.905-32.34h49.858C245.123,190.648,241.987,201.553,237.164,211.495z M246.208,161.155h-49.843
				c-0.576-11.15-2.229-22.017-4.867-32.34h45.666C241.987,138.758,245.123,149.662,246.208,161.155z"/>
                        <path d="M152.076,18.565c-0.156-0.008-0.314-0.012-0.473-0.012h-1.465c-0.158,0-0.316,0.004-0.473,0.012
				C66.963,19.608,0,87.209,0,170.155c0,4.971,4.029,9,9,9s9-4.029,9-9c0-73.426,59.535-133.207,132.871-133.6
				c73.335,0.393,132.87,60.175,132.87,133.601c0,4.971,4.029,9,9,9s9-4.029,9-9C301.741,87.209,234.779,19.608,152.076,18.565z"/>
                    </g>
                </g>
            </g>
        </svg>
    );
}